module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Regular.6936f8d3.svg";